import * as React from 'react';

interface OwnProps {
	message: string;
	reportTypes: Nullable<string[]>;
	templates?: { id: number; name: string; }[];
}

const ReportBlockActionConfirmationBody = ({ reportTypes, message, templates }: OwnProps) => (
	<>
		<div>
			{message}
		</div>
		<div className="row--padded-top bold">
			{reportTypes?.map((_name, _index) => <div key={_index}>{_name}</div>)}
		</div>
		{!!templates?.length &&
			<>
				<div className="row--padded-top">
					The following Templates will be affected:
				</div>
				<div className="row--padded-top bold">
					{templates.map((template) => (
						<div key={template.id}>{template.name}</div>
					))}
				</div>
				<div className="row--padded-top">
					You can go to <i>Settings - Job Tracking Templates</i> to update affected templates.
				</div>
			</>
		}
	</>
);

export default React.memo(ReportBlockActionConfirmationBody);
